export class ApiCollection {
    static GOOGLE_SIGN_IN: String = "/google_signin";
    static APPLICATIONS: String = "/application";
    static USERPOINTS: String = "/feedback/user_point_chart";
    static USER: String = "/user";
    static FEED_TYPE: String = "/feedback_type";
    static FEED_POINT: String = "/feedback_point";
    static NOTIFICATION: String = "/notification";


    static FEEDBACK: String = "/feedback";
    static FEEDBACK_STATUS: String = "/feedback/status_list";

    static MEDIA: String = "/media"
    static HISTROY: String = "/task/{id}/history"

    // Tasks
    static TASK: String = "/task";
    static TASK_TYPE: String = "/task/task_type";
    static TASK_STATS: String = "/task/stats";
    static TASK_COMMENT: String = "/task_comment";
    static TASK_STATUS: String = "/task_status";
    static TASK_DASHBOARD: String = "/task/dashboard";
    static TASK_EXPORT: String = "/task/export";
    static TASK_MEDIA: String = "/task_media"
    static TAGS: String = "/tags"
    static WORK_TIME: String = "/work_time";
    static WORK_TIME_ACTION: String = "/work_time/action";
    static USER_DAY_REPORT: String = "/reports/user_work_time";
    static TASK_REPORT: String = "/reports/task_work_time";

    // Deployments
    static DEPLOYMENT: String = "/deployment";
    static DEPLOYMENT_CONFIG: String = "/deployment-config";
    static DEPLOYMENT_NOTIFICATION_EMAIL: String = "/deployment-notification-email";


    // Domain
    static DOMAIN: String = "/domain";
    static DOMAIN_STATS: String = "/domain/domain_stats";
    static DOMAIN_EXPORT: String = "/domain/export";

    // Emails
    static EMAIL: String = "/email";
    static EMAIL_STATS: String = "/email/email_stats";
    static GET_EMAIL_HISTORY: String = '/email/{id}/email_history'
    static STATS: String='/email-stats';
    static STATUS_REPUTATION: String = '/email/status_reputation'


    //Email Tag
    static EMAIL_TAGS: String = "/email-tag";



    // Clients
    static CLIENT: String = "/client";

    // Regions
    static REGION: String = "/region";

    // Platform
    static PLATFORM: String = "/platform";
    static SERVICE_PROVIDER : String = "/service_provider";

    // Greetings
    static IMAGE_REQUEST = "/image-request";
    static TEMPLATE = "/template";
    static SEND_MAIL = "/image-request/send_mail";
    static TEMPLATE_Group = "/template-group";
    static FONTS = "/template/font_choices";
    static SEND_SLACK_MSG = "/image-request/send_slack_msg";
    static SLACK_CHANNELS = '/slack-channel'
    static CONFIG = '/config'
    static IMAGE_REQUEST_CONFIG = '/image-request-config'



    



    


}
